import * as React from "react"
import { cn } from "@/lib/utils"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  leftIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, leftIcon, rightIcon, style, ...props }, ref) => {
    // Calcul des paddings forcés pour éviter les superpositions avec les icônes
    // On utilise les styles en ligne pour garantir la priorité sur admin.css
    const paddingStyle: React.CSSProperties = {
      paddingLeft: leftIcon ? '3.5rem' : '1rem',
      paddingRight: rightIcon ? '3.5rem' : '1rem',
      ...style
    };

    return (
      <div className="relative w-full group">
        {leftIcon && (
          <div className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400 group-focus-within:text-[#00758d] transition-colors z-10 pointer-events-none flex items-center justify-center">
            {leftIcon}
          </div>
        )}
        <input
          type={type}
          style={paddingStyle}
          className={cn(
            "flex h-14 w-full rounded-2xl border-2 border-transparent bg-slate-50 text-sm font-bold text-[#00303c] transition-all outline-none focus:border-[#00758d] focus:bg-white focus:ring-8 focus:ring-[#00758d]/5 disabled:cursor-not-allowed disabled:opacity-50 shadow-none",
            className
          )}
          ref={ref}
          {...props}
        />
        {rightIcon && (
          <div className="absolute right-5 top-1/2 -translate-y-1/2 text-slate-400 z-10 pointer-events-none flex items-center justify-center">
            {rightIcon}
          </div>
        )}
      </div>
    )
  }
)
Input.displayName = "Input"

export { Input }
